import React, {
    useState,
    useEffect,
    useRef,
    useCallback,
    useLayoutEffect,
} from 'react'
import { Okpd2 } from '../../../../../Org/Handbook/types'
import { OrganizationInfo } from '../../../../../Org/Home/types'

import { ContractPerformance, Country } from '../../../../types'
import { CurrencyList } from '../../../types'

import { Okei } from '../../../../../Plans/Positions/Edit/types'

import {
    PerformanceContractDocPositionDraft,
    ContractPerformancePaymentAcceptance,
    ContractPerformancePaymentAcceptanceSet,
    ContractPerformancePaymentInit,
} from '../../types'

import LoadingIcon from '../../../../../../../components/LoadingIcon'
import HoverTooltip from '../../../../../../../components/HoverTooltip'

const capitalizeFirstChar = (str: string) => {
    if (str.length === 0) {
        return '-' // Возвращаем пустую строку, если входная строка пуста
    }
    return str.charAt(0).toUpperCase() + str.slice(1)
}

const formatNumber = (num: number | string | null | undefined): string => {
    if (num === null || num === undefined) return '-' // Обрабатываем пустые значения

    const parsedNum = typeof num === 'number' ? num : parseFloat(num)

    if (isNaN(parsedNum)) {
        return '-' // Обрабатываем некорректные значения
    }

    return parsedNum
        .toFixed(2) // Два знака после запятой
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') // Разделяем тысячные пробелами
        .replace('.', ',') // Заменяем точку на запятую
}

const formatNumberDot = (num: number | string | null | undefined): string => {
    if (num === null || num === undefined) return '-' // Обрабатываем пустые значения

    const parsedNum = typeof num === 'number' ? num : parseFloat(num)

    if (isNaN(parsedNum)) {
        return '-' // Обрабатываем некорректные значения
    }

    return parsedNum
        .toFixed(2) // Два знака после запятой
        .replace(' ', '') // Разделяем тысячные пробелами
        .replace(',', '.') // Заменяем точку на запятую
}

type Props = {
    index: number
    theme: string
    performanceContractPaymentsPosition: ContractPerformancePaymentInit
    performanceContractPaymentsAcceptance: ContractPerformancePaymentAcceptanceSet
    selected: boolean
    onClick: (guid: string) => void
    onRightClick: (guid: string) => void
}

const PerformancePaymentsAcceptancePopupTableRow: React.FC<Props> = (props) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null)

    useLayoutEffect(() => {
        const el = textareaRef.current
        if (!el) return
        el.style.height = 'auto'
        // даем макету стабилизироваться
        requestAnimationFrame(() => {
            el.style.height = `${el.scrollHeight + 2}px`
        })
    }, [])

    return (
        <div className="flex flex-col w-full h-fit">
            {/* строка acceptance */}
            <div
                className={
                    props.selected
                        ? 'flex flex-row gap-1 mx-1 p-1 px-2 items-center justify-center rounded text-[11px] text-[#181818] dark:text-[#FFFFFF] bg-[#FFFFFF] hover:bg-[#FFFFFF] dark:bg-[#373538] dark:hover:bg-[#373538] cursor-pointer'
                        : 'flex flex-row gap-1 mx-1 p-1 px-2 items-center justify-center rounded text-[11px] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] hover:bg-[#FFFFFF] dark:bg-[#2A282B] dark:hover:bg-[#373538] cursor-pointer'
                }
                onClick={() => {
                    props.onClick(
                        props.performanceContractPaymentsAcceptance.guid ?? ''
                    )
                }}
                onContextMenu={(e) => {
                    e.preventDefault() // Отключает стандартное контекстное меню
                    props.onRightClick(
                        props.performanceContractPaymentsAcceptance.guid ?? ''
                    )
                }}
                // onDoubleClick={() => props.onDoubleClick(props.performance.guid)}
            >
                <div
                    className="flex h-full items-center justify-center text-center cursor-pointer"
                    onClick={() => {
                        props.onClick(
                            props.performanceContractPaymentsAcceptance.guid ??
                                ''
                        )
                    }}
                >
                    <HoverTooltip tooltipText="Выбрать строку">
                        <input
                            type="checkbox"
                            className="flex min-h-6 cursor-pointer"
                            checked={props.selected}
                            onClick={(e) => e.stopPropagation()}
                            onChange={() => {
                                props.onClick(
                                    props.performanceContractPaymentsAcceptance
                                        .guid ?? ''
                                )
                            }}
                        />
                    </HoverTooltip>
                </div>
                <div className="flex w-10 h-full pt-1 items-center justify-center text-[#6A6A6A] dark:text-[#8A8A8A] cursor-pointer">
                    {props.index}
                </div>
                <div className="flex flex-1 items-center justify-start text-[#181818] dark:text-[#FFFFFF] ">
                    <div>
                        {`${
                            props.performanceContractPaymentsAcceptance
                                .acceptance_doc_name
                                ? capitalizeFirstChar(
                                      props
                                          .performanceContractPaymentsAcceptance
                                          .acceptance_doc_name
                                  )
                                : '-'
                        } № ${
                            props.performanceContractPaymentsAcceptance
                                .acceptance_doc_number
                                ? props.performanceContractPaymentsAcceptance
                                      .acceptance_doc_number
                                : '-'
                        }`}
                    </div>
                </div>
                <div className="flex w-[190px] items-center justify-center text-center text-[#181818] dark:text-[#FFFFFF] ">
                    <div>
                        {`${props.performanceContractPaymentsAcceptance.acceptance_doc_date
                            ?.split('-')
                            .reverse()
                            .join('-')
                            .replace(/[\-]/g, '.')}`}
                    </div>
                </div>
                <div className="flex flex-1 flex-col items-center justify-center text-[#181818] dark:text-[#FFFFFF] ">
                    <div className="flex w-full items-center justify-start text-[#181818] dark:text-[#FFFFFF] ">
                        {props.performanceContractPaymentsAcceptance
                            .contract_position_name
                            ? props.performanceContractPaymentsAcceptance
                                  .contract_position_name
                            : '-'}
                    </div>
                    <div className="flex w-full items-center justify-start text-[10px] text-[#6A6A6A] dark:text-[#8A8A8A] ">
                        {`${
                            props.performanceContractPaymentsAcceptance
                                .contract_position_okpd2_code
                        } - ${
                            props.performanceContractPaymentsAcceptance
                                .contract_position_okpd2_name
                        }`}
                    </div>
                </div>
                <div className="flex w-32 items-center justify-center text-center text-[#181818] dark:text-[#FFFFFF]">
                    {props.performanceContractPaymentsAcceptance.okei_name
                        ? props.performanceContractPaymentsAcceptance.okei_name
                        : '-'}
                </div>
                <div className="flex w-32 items-center justify-center text-center text-[#181818] dark:text-[#FFFFFF]">
                    {props.performanceContractPaymentsAcceptance.qty
                        ? props.performanceContractPaymentsAcceptance.qty
                        : '-'}
                </div>
                <div className="flex w-32 items-center justify-end text-[#181818] dark:text-[#FFFFFF]">
                    {props.performanceContractPaymentsAcceptance.unit_price
                        ? (
                              props.performanceContractPaymentsAcceptance
                                  .unit_price * 1
                          ).toLocaleString('ru-RU', {
                              minimumFractionDigits: 2,
                          })
                        : '-'}
                </div>
                <div className="flex w-32 items-center justify-end text-[#181818] dark:text-[#FFFFFF]">
                    {props.performanceContractPaymentsAcceptance.unit_price
                        ? props.performanceContractPaymentsAcceptance.qty
                            ? (
                                  props.performanceContractPaymentsAcceptance
                                      .qty *
                                  props.performanceContractPaymentsAcceptance
                                      .unit_price
                              ).toLocaleString('ru-RU', {
                                  minimumFractionDigits: 2,
                              })
                            : '-'
                        : '-'}
                </div>
            </div>
        </div>
    )
}

export default PerformancePaymentsAcceptancePopupTableRow
